"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGherkinDocumentFeatureSymbol = void 0;
var gherkin_utils_1 = require("@cucumber/gherkin-utils");
var vscode_languageserver_types_1 = require("vscode-languageserver-types");
var parseGherkinDocument_js_1 = require("../gherkin/parseGherkinDocument.js");
function getGherkinDocumentFeatureSymbol(gherkinSource) {
    var gherkinDocument = (0, parseGherkinDocument_js_1.parseGherkinDocument)(gherkinSource).gherkinDocument;
    if (!gherkinDocument) {
        return null;
    }
    var symbols = {};
    var data = (0, gherkin_utils_1.walkGherkinDocument)(gherkinDocument, symbols, {
        feature: function (feature, symbols) {
            var prefix = "".concat(feature.keyword, ": ");
            var name = "".concat(prefix).concat(feature.name);
            var range = makeRange(feature.location, prefix, name);
            var sym = {
                name: name,
                range: range,
                selectionRange: range,
                kind: vscode_languageserver_types_1.SymbolKind.File,
                children: [],
            };
            return __assign(__assign({}, symbols), { feature: sym, parent: sym });
        },
        rule: function (rule, symbols) {
            var _a, _b;
            var prefix = "".concat(rule.keyword, ": ");
            var name = "".concat(prefix).concat(rule.name);
            var range = makeRange(rule.location, prefix, name);
            var sym = {
                name: name,
                range: range,
                selectionRange: range,
                kind: vscode_languageserver_types_1.SymbolKind.Interface,
                children: [],
            };
            (_b = (_a = symbols.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.push(sym);
            return __assign(__assign({}, symbols), { parent: sym });
        },
        background: function (background, symbols) {
            var _a, _b;
            var prefix = "".concat(background.keyword, ": ");
            var name = "".concat(prefix).concat(background.name);
            var range = makeRange(background.location, prefix, name);
            var sym = {
                name: name,
                range: range,
                selectionRange: range,
                kind: vscode_languageserver_types_1.SymbolKind.Constructor,
                children: [],
            };
            (_b = (_a = symbols.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.push(sym);
            return symbols;
        },
        scenario: function (scenario, symbols) {
            var _a, _b;
            var prefix = "".concat(scenario.keyword, ": ");
            var name = "".concat(prefix).concat(scenario.name);
            var range = makeRange(scenario.location, prefix, name);
            var sym = {
                name: name,
                range: range,
                selectionRange: range,
                kind: vscode_languageserver_types_1.SymbolKind.Event,
                children: [],
            };
            (_b = (_a = symbols.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.push(sym);
            return symbols;
        },
    });
    return data.feature || null;
}
exports.getGherkinDocumentFeatureSymbol = getGherkinDocumentFeatureSymbol;
function makeRange(location, prefix, name) {
    var line = location.line - 1;
    var col = (location.column || 0) - 1;
    return vscode_languageserver_types_1.Range.create(vscode_languageserver_types_1.Position.create(line, col + prefix.length), vscode_languageserver_types_1.Position.create(line, col + name.length));
}
//# sourceMappingURL=getGherkinDocumentFeatureSymbol.js.map